import user from '@/stores/user';
import { trackEvent } from '@/utils/gtag';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageView = () => {
    const { userDetail } = user;
    const location = useLocation();

    useEffect(() => {
        trackEvent('page_view', {
            userId: userDetail?.id,
            address: userDetail?.ethAddress,
            tgId: userDetail?.tgId,
            xId: userDetail?.xId,
            page_path: location.pathname,
        });
    }, [location.pathname]);
};
